import React, { useState } from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import { useDialogStore } from '@stores/dialog.store'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'
import PageRoutes from '@utils/page-routes'

interface Props {
  titleId: string
}

const UnpublishDialog: React.FC<Props> = ({ titleId }) => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const [unpublishing, setUnpublishing] = useState(false)

  const handleUnpublish = async (): Promise<void> => {
    setUnpublishing(true)
    const [resp, errors] = await http.post(ApiRoutes.apiTitleUnpublishPath(), { uuid: titleId })
    if (!resp) {
      console.error(errors)
      setUnpublishing(false)
      return
    }

    // Redirect to the editor since this path is only possible for authors
    window.location.href = PageRoutes.titleEditScorePath(titleId)
  }

  return (
    <Dialog
      name="unpublish_title"
      title={t('action.unpublish')}
      maxWidth={490}
      cancelBtn
      okBtn={{
        text: t('action.unpublish'),
        action: handleUnpublish,
        disabled: unpublishing,
      }}>
      <p>
        <Trans i18nKey="messages.unpublish">
          If you need to make changes to your score use
          <button
            type="button"
            className="orange-link"
            onClick={() => openDialog('edit_score', { closeOthers: true })}>
            Edit Score
          </button>
          to return the original score, and publish an update. If you unpublish your score it will
          be removed from Noteflight Music.
        </Trans>
      </p>
    </Dialog>
  )
}

export default UnpublishDialog
